import React from 'react';
import { loadStripe } from '@stripe/stripe-js/pure';
import {
    Elements,
    useElements,
    useStripe,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
} from '@stripe/react-stripe-js';
import { PropTypes } from 'prop-types';
import CARD_ELEMENT_OPTIONS from './CheckoutFormStyle';
import { STRIPE_API_KEY } from './constants';

// Setup Stripe.js and the Elements provider
loadStripe.setLoadParameters({ advancedFraudSignals: false });
const stripePromise = loadStripe(STRIPE_API_KEY);

function CheckoutForm({ handleChange }) {
    const stripe = useStripe();
    const elements = useElements();

    return (
        <div>
            <div className="stripInputField">
                <CardNumberElement
                    options={{
                        ...CARD_ELEMENT_OPTIONS,
                        placeholder: 'xxxx-xxxx-xxxx-xxxx',
                        showIcon: true,
                    }}
                    onChange={(e) => {
                        handleChange(e, stripe, elements);
                    }}
                />
            </div>
            <div className="monthCvcContainer">
                <span className="stripInputField w-100">
                    <CardExpiryElement
                        options={CARD_ELEMENT_OPTIONS}
                        onChange={(e) => {
                            handleChange(e, stripe, elements);
                        }}
                    />
                </span>

                <span className="stripInputField w-100">
                    <CardCvcElement
                        options={CARD_ELEMENT_OPTIONS}
                        onChange={(e) => {
                            handleChange(e, stripe, elements);
                        }}
                    />
                </span>
            </div>
        </div>
    );
}

CheckoutForm.propTypes = {
    // function to be called when payment field's value is changed
    handleChange: PropTypes.func.isRequired,
};

function CheckoutFormContainer({ handleChange }) {
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm handleChange={handleChange} />
        </Elements>
    );
}

CheckoutFormContainer.propTypes = {
    // function to be called when payment field's value is changed
    handleChange: PropTypes.func.isRequired,
};

export default CheckoutFormContainer;
